module.exports = __webpack_public_path__ + "static/media/style.b4d4a30a.less";